import { render, staticRenderFns } from "./aniChart.vue?vue&type=template&id=2344070c&scoped=true"
import script from "./aniChart.vue?vue&type=script&lang=js"
export * from "./aniChart.vue?vue&type=script&lang=js"
import style0 from "./aniChart.vue?vue&type=style&index=0&id=2344070c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2344070c",
  null
  
)

export default component.exports